/*

  From: https://www.npmjs.com/package/draft-js-import-element
  Version used: 1.2.1
  Last modified: 11.30.2017
  Things modified:
    - Removed "use strict" (only needed in npm package)
    - Updated draftJsImportelement path from "draft-js-import-element"
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stateFromMarkdown;

var _MarkdownParser = require('./MarkdownParser');

var _MarkdownParser2 = _interopRequireDefault(_MarkdownParser);

var _draftJsImportElement = require('../../draft-js-import-element');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stateFromMarkdown(markdown, options) {
  var element = _MarkdownParser2.default.parse(markdown, { getAST: true });
  return (0, _draftJsImportElement.stateFromElement)(element, options);
}


// WEBPACK FOOTER //
// ./src/shared/libraries/draft-js-import-markdown/lib/stateFromMarkdown.js